import {
  Calendar,
  Settings,
  CreditCard,
  Users,
  BarChart,
  Mail,
  Globe,
  ListChecks,
  Clock,
  Lock,
  Video,
} from "lucide-react";

const featuresList = [
  {
    title: "Advanced Event Creation",
    description:
      "Create detailed event pages with customizable agendas, speaker profiles, and rich media",
    icon: <Calendar className="h-10 w-10 text-cecure-600" />,
  },
  {
    title: "Custom Registration Forms",
    description:
      "Design registration forms with multiple ticket types and gather exactly the information you need",
    icon: <ListChecks className="h-10 w-10 text-cecure-600" />,
  },
  {
    title: "Secure Payment Processing",
    description:
      "Integrate with Stripe and PayPal to securely process ticket payments",
    icon: <CreditCard className="h-10 w-10 text-cecure-600" />,
  },
  {
    title: "Attendee Management",
    description:
      "Easily manage registrations, send communications, and track attendance",
    icon: <Users className="h-10 w-10 text-cecure-600" />,
  },
  {
    title: "Automated Emails",
    description:
      "Send confirmation emails, reminders, and follow-ups automatically",
    icon: <Mail className="h-10 w-10 text-cecure-600" />,
  },
  {
    title: "Detailed Analytics",
    description: "Track registration rates, attendance, and engagement metrics",
    icon: <BarChart className="h-10 w-10 text-cecure-600" />,
  },
  {
    title: "Global Accessibility",
    description:
      "Host events accessible to attendees worldwide with multi-language support",
    icon: <Globe className="h-10 w-10 text-cecure-600" />,
  },
  {
    title: "Event Customization",
    description:
      "Customize your event pages with your branding and preferred layout",
    icon: <Settings className="h-10 w-10 text-cecure-600" />,
  },
  {
    title: "Waitlist Management",
    description:
      "Automatically manage waitlists for sold-out events and notify when spots open up",
    icon: <Clock className="h-10 w-10 text-cecure-600" />,
  },
  {
    title: "Data Security",
    description:
      "Enterprise-grade security to protect attendee and payment information",
    icon: <Lock className="h-10 w-10 text-cecure-600" />,
  },
  {
    title: "Video conferencing",
    description:
      "Run your virtual events smoothly with built-in video conferencing—no third-party tools needed.",
    icon: <Video className="h-10 w-10 text-cecure-600" />,
  },
];

const Features = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-cecure-900 mb-4">
            Everything You Need for Successful Events
          </h2>
          <p className="text-lg text-gray-600">
            CecureStream Events combines powerful features with an intuitive
            interface, making event management simple and effective.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {featuresList.map((feature, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-lg shadow-sm card-hover-effect"
            >
              <div className="mb-4">{feature.icon}</div>
              <h3 className="text-xl font-semibold text-cecure-800 mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
